import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import TbxLoadingOverlay from '../TbxLoadingOverlay/TbxLoadingOverlay'

const classes = {
    progress: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh',
    },
}

const PageSpinner = () => {
    const { t } = useTranslation()
    return (
        <Box sx={classes.progress}>
            <TbxLoadingOverlay
                labelText={t('Loading store settings and materials...')}
                progressColor="secondary"
            />
        </Box>
    )
}

export default PageSpinner
